import { useTranslation } from "@/lib/i18n";
import { useDashboardData } from "@/features/shared/hooks";
import { AdditionalWidgetData } from "@/types/additional-widget-data";
import { TimeSeriesTable } from "@/features/shared/widgets/components";
import { WarningColors } from "@/features/shared/widgets/types";
import useRefetchWidget from "@/features/shared/widgets/hooks/useRefetchWidget";

const getColorCodeForValue = (value: number | string) => {
  if (typeof value !== "number") return WarningColors.NONE;
  if (value >= 50) return WarningColors.ERROR;
  if (value >= 20) return WarningColors.INFO;
  if (value >= 10) return WarningColors.WARNING;
  if (value >= 0) return WarningColors.SUCCESS;

  return WarningColors.NONE;
};

type Props = {
  id: string;
  data: AdditionalWidgetData;
};

const Sight = ({ id, data }: Props) => {
  const { t } = useTranslation();
  const { selectedTimeRange } = useDashboardData();

  useRefetchWidget(id);

  if (!data || !data.data?.length) {
    return <span>{t("widgets.no_data")}</span>;
  }

  return (
    <TimeSeriesTable
      series={data.data}
      timeRange={selectedTimeRange}
      getColorCodeForValue={getColorCodeForValue}
    />
  );
};

export default Sight;
